import React from "react";
import SEO from "../components/SEO";
import { getBreadcrumbSchema } from "../utils/schema";
import "./Legal.css";

export const Terms = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Terms of Service', url: '/terms' }
  ]);

  return (
    <div className="legal-page">
      <SEO
        title="Terms of Service | Brightson Accounting Limited"
        description="Terms of service for Brightson Accounting Limited. Professional accounting services in Wolverhampton."
        canonical="/terms"
        schema={breadcrumbSchema}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: December 2025</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the services of Brightson Accounting Limited, you agree to be 
              bound by these Terms of Service. If you do not agree to these terms, please do not use 
              our services.
            </p>

            <h2>2. Services Provided</h2>
            <p>
              Brightson Accounting Limited provides professional accounting, bookkeeping, tax planning, 
              and related financial services to businesses and individuals in Wolverhampton and the 
              surrounding areas. Services include:
            </p>
            <ul>
              <li>Annual accounts preparation and filing</li>
              <li>Tax planning and advisory</li>
              <li>HMRC specialist support</li>
              <li>Self assessment tax returns</li>
              <li>Payroll and VAT services</li>
              <li>Business start-up support</li>
            </ul>

            <h2>3. Professional Standards</h2>
            <p>
              Our services are provided by FCCA and MAAT qualified accountants in accordance with 
              professional standards set by ACCA (Association of Chartered Certified Accountants) 
              and AAT (Association of Accounting Technicians).
            </p>

            <h2>4. Client Responsibilities</h2>
            <p>As a client, you agree to:</p>
            <ul>
              <li>Provide accurate, complete, and timely information required for our services</li>
              <li>Respond promptly to requests for information or documentation</li>
              <li>Review and approve all work before submission to HMRC or Companies House</li>
              <li>Pay all fees in accordance with agreed terms</li>
              <li>Notify us immediately of any changes to your circumstances</li>
            </ul>

            <h2>5. Fees and Payment</h2>
            <p>
              Fees are agreed upfront on a fixed-fee or case-by-case basis. Payment terms will be 
              specified in your engagement letter. Late payments may incur interest charges. We 
              reserve the right to withhold services or documents until outstanding fees are settled.
            </p>

            <h2>6. Confidentiality</h2>
            <p>
              We maintain strict confidentiality of all client information in accordance with 
              professional standards and UK data protection laws. Client information will not be 
              disclosed to third parties except where required by law (HMRC, Companies House) or 
              with your explicit consent.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
              While we exercise professional care and diligence in all our work, our liability is 
              limited to the fees paid for the specific service in question. We are not liable for 
              losses arising from:
            </p>
            <ul>
              <li>Inaccurate or incomplete information provided by you</li>
              <li>Failure to follow our advice</li>
              <li>Changes in tax law or HMRC interpretation after advice is given</li>
              <li>Delays caused by third parties (HMRC, Companies House, etc.)</li>
            </ul>

            <h2>8. Professional Indemnity Insurance</h2>
            <p>
              We maintain professional indemnity insurance as required by our professional bodies. 
              Details available upon request.
            </p>

            <h2>9. Termination of Services</h2>
            <p>
              Either party may terminate the professional relationship with reasonable notice. Upon 
              termination, all outstanding fees must be settled, and we will provide your records 
              as required by professional standards.
            </p>

            <h2>10. Complaints Procedure</h2>
            <p>
              If you have a complaint about our services, please contact us in writing. We will 
              investigate and respond within a reasonable timeframe. If unresolved, you may refer 
              the matter to ACCA or AAT.
            </p>

            <h2>11. Governing Law</h2>
            <p>
              These Terms of Service are governed by the laws of England and Wales. Any disputes 
              shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>

            <h2>12. Changes to Terms</h2>
            <p>
              We reserve the right to update these terms from time to time. Changes will be posted 
              on this page with an updated revision date.
            </p>

            <h2>13. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:info@brightsonaccounting.co.uk">info@brightsonaccounting.co.uk</a><br/>
              <strong>Registered Office:</strong> 71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ<br/>
              <strong>Service area:</strong> Serving Wolverhampton and the West Midlands
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
